import React, { Fragment } from 'react';

const ModalUpdateAssociateUsers = props => {
  return (
    <div
      data-close="ok"
      onClick={props.handleModal}
      className={props.modal ? `container-modal` : `container-modal hide`}
    >
      <section className="module-title modal-title">
        <h2>{props.language.account.createDriver.associateUsers}</h2>
        <p id="file-error-associate-users" className="error none">
          {props.language.account.others.incorrectFormat}
        </p>
        {
          (props.statusFile && props.statusFile !== 200) && (
            <PrivateComponentShowErrors {...props} />
          )
        }
        <a>
          <i data-close="ok" onClick={props.handleModal} className="fas fa-times-circle" />
        </a>
        {props.statusFile == null && (
          <Fragment>
            <p className="normal-text">
              {props.language.account.modalDriver.normalTextUserAssociateUsers}{' '}
              <strong onClick={props.handleDownload} className="active-link">
                {props.language.account.modalDriver.buttonDownload}
              </strong>
            </p>
            <div className="alert alert-warning mt-1" style={{ fontSize: '1rem' }}>
              <i className="fas fa-exclamation-triangle mr-1" />
              <span dangerouslySetInnerHTML={{ __html: props.language.account.others.disclaimerAssociateUsers }} />
            </div>
          </Fragment>
        )}
      </section>
      {props.statusFile == null && (
        <Fragment>
          <div className={`box-modal max500`}>
            <section id="modal-update" className="base-form">
              <div className="box-form">
                <div className="container-file">
                  <label htmlFor="file-associate-users" className="custom-file-upload">
                    {props.language.account.modalDriver.examine}
                  </label>
                  <span id="file-1-associate-users" />
                  <input
                    required
                    onChange={props.handleUploadValue}
                    id="file-associate-users"
                    name="file-associate-users"
                    type="file"
                  />
                </div>
              </div>
            </section>
          </div>
          <div className={'box-form islabel top center modal-button-box '}>
            <div>
              {props.loadingFile ? (
                <div className="spiner">
                  <i className="fas fa-spinner fa-spin" /> {props.language.account.others.loading}
                </div>
              ) : (
                <input
                  onClick={props.handleUpload}
                  id="btn-upload-associate-users"
                  type="button"
                  value={props.language.account.modalDriver.buttonUpdateFile}
                />
              )}
            </div>
          </div>
        </Fragment>
      )}
      {props.statusFile === 200 && (
        <PrivateComponentSuccessMessage {...props} />
      )}
    </div>
  )
};

export default ModalUpdateAssociateUsers;

// ============================================
// Private Component
// ============================================
const PrivateComponentShowErrors = (props) => {
  let code = props.datosFile.error.messageCode;
  let messageError = props.language.error[code];

  switch (code) {
    case 'invalidFileFormat':
    case 'cod6505':
      messageError = `${messageError} (${props.datosFile.error.params[0]})`
      break;
    default:
      break;
  }

  return (
    <Fragment>
      <p className="error mb-2">{messageError}</p>
    </Fragment>
  )
}

const PrivateComponentSuccessMessage = (props) => {
  let feedbackColor, feedbackMessage, feedbackIcon;
  const { datosFile } = props;
  const { errorsDetected, totalErrors } = datosFile;

  if (errorsDetected) {
    feedbackColor = 'yellow';
    feedbackMessage = props.language.account.modalDriver.messageErrorResultAssociateUsers.replace('{totalErrors}', totalErrors);
    feedbackIcon = 'fas fa-exclamation-circle';
  } else {
    feedbackColor = 'green';
    feedbackMessage = props.language.account.modalDriver.feedBackDriverUpdateOne;
    feedbackIcon = 'fas fa-check-circle';
  }

  return (
    <div className={`box-modal max500`}>
      <section className={`feed-back ${feedbackColor}`}>
        <div>
          <i className={feedbackIcon} />
        </div>
        <div>
          <p dangerouslySetInnerHTML={{ __html: feedbackMessage}} />
        </div>
      </section>
    </div>
  )
}



// WEBPACK FOOTER //
// ./source/client/components/account_user/modalUpdateAssociateUsers.jsx